{
  "el-GR": {
    "model": {
      "profile": {
        "id": "Αναγνωριστικό χρήστη",
        "userName": "Όνομα χρήστη",
        "email": "Διεύθυνση ηλεκτρονικού ταχυδρομείου",
        "emailConfirmed": "Η διεύθυνση ηλεκτρονικού ταχυδρομείου έχει επιβεβαιωθεί.",
        "phoneNumber": "Αριθμός τηλεφώνου",
        "phoneNumberConfirmed": "Αριθμός τηλεφώνου επιβεβαιωμένος.",
        "twoFactorEnabled": "Έχει ενεργοποιηθεί η επαλήθευση δύο παραγόντων.",
        "lockoutEnd": "Λήξη χρονικού διαστήματος αποκλεισμού",
        "lockoutEnabled": "Ενεργοποιημένη η λειτουργία αποκλεισμού.",
        "accessFailedCount": "Αριθμός αποτυχημένων προσπαθειών πρόσβασης",
        "firstName": "Όνομα",
        "lastName": "Επώνυμο",
        "picture": "Εικόνα προφίλ",
        "organisationName": "Οργανισμός",
        "name": "Όνομα",
        "roles": "Ρόλοι"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Επιβεβαιωμένο"
      },
      "action": {
        "resetPassword.tooltip": "Αποστολή οδηγιών επαναφοράς κωδικού πρόσβασης στον χρήστη μέσω ηλεκτρονικού ταχυδρομείου."
      },
      "message": {
        "resetPassword.success": "Στο χρήστη εστάλη ένα μήνυμα ηλεκτρονικού ταχυδρομείου με οδηγίες για την επαναφορά του κωδικού πρόσβασής του."
      }
    }
  }
}